<template>
  <VanPopup
    :show="showPoseEdit"
    class="h-full w-full"
    position="left"
    safe-area-inset-top
    teleport="body"
    @update:show="emit('update:showPoseEdit', $event)"
  >
    <ThreadsNav
      :go-back="() => emit('update:showPoseEdit', false)"
      :show-center="false"
      show-back
    >
      <!-- <template #right>
        <button class="btn btn-primary btn-sm" @click="showPoseDiyModal = true">
          {{ $t("painting.people.newPoseDiy") }}
        </button>
      </template> -->
    </ThreadsNav>
    <div class="h-full overflow-hidden">
      <div class="h-full grid grid-rows-[auto_1fr]">
        <div>
          <Tabs
            :active="showPoseType"
            @change="onTabChange"
            @update:active="emit('update:showPoseType', $event)"
          >
            <Tab :title="$t('painting.individual')"></Tab>
            <Tab :title="$t('painting.multiplePeople')"></Tab>
            <Tab :title="$t('painting.iLike')"></Tab>
            <!-- <Tab :title="$t('painting.custom')"></Tab> -->
          </Tabs>
        </div>
        <ThreadList
          ref="listRef"
          :enablePullLoad="false"
          :on-scroll-load="fetchMedia"
          class="h-full overflow-auto"
        >
          <div class="grid grid-cols-2 gap-4 p-4">
            <div
              v-for="item in list"
              :id="String(item.id) + showPoseType"
              :key="String(item.previewMediaId) + String(item.id)"
            >
              <div class="relative mb-3">
                <BaseImg
                  :url="
                    showPoseType === 3
                      ? item.poseMedia?.url
                      : showPoseType === 2
                      ? item.mateLike?.media?.url || item.previewMedia.url
                      : item.previewMedia.url
                  "
                  ratio="3:4"
                />
                <span
                  v-if="item.mateLike"
                  class="absolute bottom-0 left-0 py-1 px-3 bg-[rgba(0,0,0,0.6)]"
                >
                  {{ item.mateLike.title }}
                </span>
              </div>
              <div
                v-if="[0, 1, 2].includes(showPoseType)"
                class="flex gap-1 mt-2"
              >
                <button
                  class="btn-xs rounded font-normal h-8 btn btn-primary flex-1"
                  @click="clickSelect(item.previewMedia.url)"
                >
                  {{ $t("Buttons.select") }}
                </button>
                <button
                  :style="item.mateLike ? 'color: #ff4d4f' : ''"
                  class="btn-xs rounded font-normal h-8 flex flex-nowrap justify-center items-center btn flex-1"
                  @click="clickLike(item)"
                >
                  <i class="iconfont icon-heart-fill"></i>
                  {{ item.mateLike ? $t("Social.liked") : $t("Social.likes") }}
                </button>
              </div>

              <div v-if="showPoseType === 2" class="flex gap-1 mt-1">
                <button
                  class="btn-xs rounded font-normal h-8 flex flex-nowrap justify-center items-center btn flex-1"
                  @click="
                    (activeMateLike = item.mateLike),
                      (showImgUploadPopup = true)
                  "
                >
                  {{ $t("trait.changeCover") }}
                </button>
                <button
                  class="btn-xs rounded font-normal h-8 flex flex-nowrap justify-center items-center btn flex-1"
                  @click="clickEditName(item)"
                >
                  {{ $t("Buttons.modifyNaming") }}
                </button>
              </div>

              <div v-if="showPoseType === 3" class="flex gap-1 mt-2">
                <button
                  class="btn-xs rounded font-normal h-8 btn btn-primary flex-1"
                  @click="
                    clickSelect(item.poseMedia?.url!, [
                      item.depthMedia?.url!,
                      // item.cannyMedia?.url!,
                      // item.normalMedia?.url!,
                    ])
                  "
                >
                  {{ $t("Buttons.select") }}
                </button>
                <button
                  class="btn-xs rounded font-normal h-8 flex flex-nowrap justify-center items-center btn flex-1"
                  @click="removeCustomPose(item.id!)"
                >
                  <i class="iconfont icon-delete"></i>
                  {{ $t("Buttons.delete") }}
                </button>
              </div>
            </div>
          </div>
        </ThreadList>
      </div>
    </div>

    <CropImageOverlay
      ref="cropImageOverlayRef"
      :crop-aspect-ratio="cropAspectRatio"
      :on-finished="onCropImageFinished"
      :show-ratio-select="showRatioSelect"
      @update:crop-aspect-ratio="onCropAspectRatioChange"
    />
    <media-select-popup
      v-model:show="showImgUploadPopup"
      :enable-go-image-gen="false"
      :max-count="1"
      :multiple="false"
      :upload-type="7"
      media-type="img"
      replace
      @on-media-selected="onMediaSelected"
    />

    <Dialog
      v-model:show="showNameEditPopup"
      :title="$t('Texts.enterName')"
      show-cancel-button
      @confirm="clickEditNameConfirm"
    >
      <Field
        v-model="editName"
        :placeholder="$t('Texts.enterName')"
        class="my-4"
      />
    </Dialog>
    <VanPopup
      v-model:show="showPoseDiyModal"
      class="h-full"
      position="bottom"
      safe-area-inset-top
    >
      <div class="h-full grid grid-rows-[auto_1fr]">
        <ThreadsNav
          :go-back="() => (showPoseDiyModal = false)"
          :show-center="false"
          show-back
        >
        </ThreadsNav>
        <iframe
          id="pose-diy-iframe"
          ref="iframeDOM"
          :src="openPoseUrl"
          class="h-full w-full"
          @load="iframeLoaded"
        ></iframe>
      </div>
    </VanPopup>
  </VanPopup>
</template>

<script lang="ts" setup>
import {
  ApiGetPresetMedia,
  ApiPostMateLike,
  ApiDeleteMateLike,
  ApiPutMateLike,
  ApiPostPoseMedia,
  ApiGetPosePage,
  ApiDeletePoseMedia,
} from "@/apis/paint";
import {
  Tab,
  Tabs,
  showFailToast,
  showLoadingToast,
  Dialog,
  Field,
  showSuccessToast,
  showConfirmDialog,
} from "vant";
import MediaSelectPopup from "@/components/mobile/media/MediaSelectPopup.vue";
import { onMounted } from "vue";
import { ref } from "vue";
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { PropType } from "vue";
import { useMate } from "@/stores/mate";
import api from "@/modules/api";
import { onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { watch } from "vue";
import { CropImageOverlayInstance } from "@/components/mobile/media/CropImageOverlay.vue";

const { t, locale } = useI18n();
// @ts-ignore
const openPoseUrl = ref<string>(import.meta.env.VITE_OPEN_POSE_URL);
const showNameEditPopup = ref(false);
const ratio = ref("3:4");
const cropAspectRatio = ref(3 / 4);
const mateStore = useMate();

const activeMateLike = ref<MateLike>();
const editName = ref("");

const showImgUploadPopup = ref(false);

const onMediaSelected = async (media: Array<any>) => {
  const { id, title } = activeMateLike.value!;
  const toast = showLoadingToast({
    message: t("Messge.changingCover"),
    duration: 0,
    zIndex: 9999,
  });
  try {
    await ApiPutMateLike(id!, {
      title,
      mediaId: media[0].mediaId,
    });
    list.value = list.value.map((item) => {
      if (item.mateLike?.id === id) item.mateLike!.media = media[0];
      return item;
    });
  } finally {
    toast.close();
  }
};

const clickEditName = (item: PresetMedia) => {
  activeMateLike.value = item.mateLike;
  editName.value = activeMateLike.value!.title;
  showNameEditPopup.value = true;
};
const clickEditNameConfirm = () => {
  showNameEditPopup.value = false;
  const { id, mediaId } = activeMateLike.value!;
  ApiPutMateLike(id!, {
    title: editName.value,
    mediaId: mediaId ?? undefined,
  });
  list.value = list.value.map((item) => {
    if (item.mateLike?.id === id) item.mateLike!.title = editName.value;
    return item;
  });
};

const props = defineProps({
  type: {
    type: String as PropType<"Pose" | "Env" | "Clothes">,
    required: true,
  },
  showRatioSelect: {
    type: Boolean,
    default: true,
  },
  showPoseType: {
    type: Number,
    default: 0,
  },
  showPoseEdit: {
    type: Boolean,
    default: false,
  },
});
const { type } = props;

watch(
  () => props.showPoseEdit,
  (val) => {
    if (val) {
      onTabChange(props.showPoseType);
    }
  }
);

const emit = defineEmits([
  "update:showPoseEdit",
  "update:selectedMedia",
  "update:selectedCustomPose",
  "update:showPoseType",
]);

const list = ref<Array<PresetMedia>>([]);
const cropImageOverlayRef = ref<CropImageOverlayInstance>();

const page = ref(1);
const listRef = ref<ThreadListInstance>();

const onTabChange = (item: number) => {
  listRef.value?.scrollTo(0);
  list.value = [];
  listRef.value?.resetScrollLoadingState();
  page.value = 1;
};

const clickSelect = (url: string, others?: string[]) => {
  cropImageOverlayRef.value?.showCropper(url, others);
};

const onCropImageFinished = async (
  base64: string,
  file: File,
  otherFiles: File[]
) => {
  // 1. 获取裁剪后的图片
  const toast = showLoadingToast({
    message: t("Message.uploading"),
    duration: 0,
    zIndex: 9999,
  });
  try {
    // 2. 上传图片
    let promises = [api.uploadMedia(7, file, mateStore.currentMate!.id)];
    if (otherFiles.length) {
      promises = promises.concat(
        otherFiles.map((f) => api.uploadMedia(7, f, mateStore.currentMate!.id))
      );
    }

    const res = await Promise.all(promises);
    const [{ item }] = res;
    if (res.length > 1) {
      //@ts-ignore
      return emit("update:selectedCustomPose", {
        ratio: ratio.value,
        customPoseUrl: res.map((r) => r.item.url),
      });
    }
    emit("update:selectedMedia", {
      mediaId: item.id,
      url: item.url,
      ratio: ratio.value,
    });
  } catch (e: any) {
    showFailToast(`${t("Message.uploadFailed")}，${e.message}`);
    throw e;
  } finally {
    toast.close();
  }
};

const clickLike = async (item: PresetMedia) => {
  const toast = showLoadingToast({
    message: t("Message.inOperation"),
    duration: 0,
  });
  try {
    if (item.mateLike) {
      // 不喜欢
      await ApiDeleteMateLike(item.mateLike.id!);
      item.mateLike = undefined;
      if (props.showPoseType === 2) {
        list.value.splice(list.value.indexOf(item), 1);
      }
    } else {
      const res = await ApiPostMateLike(item);
      item.mateLike = res.item;
    }
  } finally {
    toast.close();
  }
};

const fetchMedia = async () => {
  if (props.showPoseType === 3) {
    const res = await ApiGetPosePage({
      pagination: {
        page: page.value,
        perPage: 6,
      },
      sort: {
        field: "id",
        order: "desc",
      },
    });
    list.value = [...list.value, ...res.page.data];
    if (res.page.data.length !== 0) page.value++;
    else if (list.value.length === 0) showPoseDiyModal.value = true;
    return res.page.data.length === 6;
  }

  let filter: any = { type };
  if (props.showPoseType === 0) {
    filter.group = "Single";
  } else if (props.showPoseType === 1) {
    filter.group = "Multiple";
  } else if (props.showPoseType === 2) {
    filter.mateId = mateStore.currentMate?.id;
  }
  const res = await ApiGetPresetMedia({
    filter,
    pagination: {
      page: page.value,
      perPage: 6,
    },
  });
  list.value = [...list.value, ...res.page.data];
  if (res.page.data.length !== 0) page.value++;
  return res.page.data.length === 6;
};

const onCropAspectRatioChange = (_ratio: string) => {
  ratio.value = _ratio;
  const [w, h] = _ratio.split(":").map(Number);
  cropAspectRatio.value = w / h;
};

// 自定义姿势
const iframeDOM = ref<any>(null);
const showPoseDiyModal = ref(false);

const onPoseMessage = async (e: MessageEvent) => {
  if (e?.data?.cmd === "Generate") {
    const { image } = e.data;
    image.data = JSON.stringify(image.data);
    const loading = showLoadingToast({
      message: t("Message.uploading"),
      duration: 0,
      zIndex: 9999,
    });
    await ApiPostPoseMedia(image);
    loading.close();
    showSuccessToast(t("Message.uploadSuccessful"));
    showPoseDiyModal.value = false;
    emit("update:showPoseType", 3);
    onTabChange(3);
  }
};

let isLoaded = false;
const iframeLoaded = () => {
  if (isLoaded) return;
  isLoaded = true;
  const iframeDOM: any = document.getElementById("pose-diy-iframe");
  iframeDOM?.contentWindow.postMessage(
    {
      cmd: "UpdateLocale",
      data: locale.value,
    },
    "*"
  );
};

const removeCustomPose = async (id: number) => {
  try {
    await showConfirmDialog({
      message: t("Message.deleteConfirm"),
      confirmButtonText: t(`Buttons.confirm`),
      cancelButtonText: t(`Buttons.cancel`),
    });
  } catch (e) {
    return;
  }
  const loading = showLoadingToast({
    message: t("Message.deleting"),
    duration: 0,
  });
  await ApiDeletePoseMedia(id);
  loading.close();
  showSuccessToast(t("Message.deleteSuccessful"));
  list.value = list.value.filter((item) => item.id !== id);
};

onMounted(async () => {
  window.addEventListener("message", onPoseMessage, false);
});
onUnmounted(() => {
  window.removeEventListener("message", onPoseMessage);
});
</script>
